export default __webpack_public_path__ + "static/media/usdt-logo.6dc09781.svg";